import { RowDetails, RowResponse } from "../../api-models/response/DataGridResponse";
import { MapItemResponse } from "../../api-models/response/MapItemResponse";
import { formatValues } from "../../components/datatable/GridValuesFormatter";
import { DisplayValues, RowItemData } from "../../components/datatable/interfaces";
import { SewerObjectType } from "../../generated/SewerObjects";
import { translationService } from "../translation/TranslationService";

export const getTranslationKeyForType = (type: SewerObjectType) => {
  return `general.${Object.keys(SewerObjectType)
    .find((key) => SewerObjectType[key] === type)
    ?.toLowerCase()}`;
};

export class SewerObject implements RowItemData {
  id: number;
  path: string;
  private properties: DisplayValues;
  private objectTypeTranslationKey: string;
  private parentPagePath: string;

  static _constructorFromMapItem(mapObject: MapItemResponse, parentPagePath: string) {
    const object = new SewerObject(mapObject.objectId, mapObject.details, parentPagePath);
    object.properties.Name.hasMissingGeometry = mapObject.coordinates.length === 0;
    return object;
  }

  static _constructorFromRowItem(sewerObjectRow: RowResponse, parentPagePath: string) {
    const object = new SewerObject(sewerObjectRow.id, sewerObjectRow.details, parentPagePath);
    object.properties.Name.hasIssues = sewerObjectRow.hasIssues;
    object.properties.Name.maxIssueSeverity = sewerObjectRow.maxIssueSeverity;
    return object;
  }

  private constructor(
    objectId: number,
    properties: RowDetails,
    parentPagePath: string,
  ) {
    this.parentPagePath = parentPagePath;
    this.properties = properties;
    this.id = objectId;
    this.objectTypeTranslationKey = getTranslationKeyForType(this.properties.Type.value);
    this.properties.Name.path = this.getPath();
    this.properties.Project.path = this.getProjectPath();
    this.properties.Name.entityName = this.getEntityName();
    this.path = this.getPath();
  }

  get displayValues() {
    this.properties = formatValues(this.properties);
    this.properties.Type.toDisplay = translationService.translate(this.objectTypeTranslationKey);
    return this.properties;
  }

  private getEntityName(): string {
    return SewerObjectType[this.properties.Type.value];
  }

  private getPath() {
    return `${this.parentPagePath}/sewer-objects/${this.getEntityName().toLowerCase()}/:id`;
  }

  private getProjectPath(): any {
    return "/projects/:id";
  }
}
